import { Mic, MicOff, Volume2, VolumeX } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface VoiceModeToggleProps {
  voiceMode: boolean;
  onToggle: () => void;
  autoSpeak: boolean;
  onAutoSpeakToggle: () => void;
  isListening?: boolean;
  isSpeaking?: boolean;
}

export function VoiceModeToggle({
  voiceMode,
  onToggle,
  autoSpeak,
  onAutoSpeakToggle,
  isListening,
  isSpeaking,
}: VoiceModeToggleProps) {
  return (
    <div className="flex items-center gap-1">
      <Button
        variant="ghost"
        size="icon"
        onClick={onToggle}
        className={cn(
          "h-8 w-8 rounded-full transition-all",
          voiceMode && "bg-primary/20 text-primary",
          isListening && "animate-pulse bg-destructive/20 text-destructive"
        )}
        title={voiceMode ? "Voice mode on" : "Voice mode off"}
      >
        {voiceMode ? (
          <Mic className="h-4 w-4" />
        ) : (
          <MicOff className="h-4 w-4 text-muted-foreground" />
        )}
      </Button>
      
      <Button
        variant="ghost"
        size="icon"
        onClick={onAutoSpeakToggle}
        className={cn(
          "h-8 w-8 rounded-full transition-all",
          autoSpeak && "bg-primary/20 text-primary",
          isSpeaking && "animate-pulse"
        )}
        title={autoSpeak ? "AI voice on" : "AI voice off"}
      >
        {autoSpeak ? (
          <Volume2 className="h-4 w-4" />
        ) : (
          <VolumeX className="h-4 w-4 text-muted-foreground" />
        )}
      </Button>
    </div>
  );
}
